var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CalendarBlank",
    clipPath: "url(#clip0_743_7244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.625 0.4375V2.1875M4.375 0.4375V2.1875M1.3125 4.8125H12.6875M1.82955 1.3125H12.1705C12.456 1.3125 12.6875 1.54399 12.6875 1.82955V12.1705C12.6875 12.456 12.456 12.6875 12.1705 12.6875H1.82955C1.54399 12.6875 1.3125 12.456 1.3125 12.1705V1.82955C1.3125 1.54399 1.54399 1.3125 1.82955 1.3125Z",
    stroke: "#0D1126",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_7244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlank);
export default __webpack_public_path__ + "static/media/CalendarBlank.c4f9395da404e295926bf769cd1f8e5e.svg";
export { ForwardRef as ReactComponent };